import { formatCurrency } from '../../utils/CommonUtils';

/**
 * Грошова сума з моноширинними цифрами.
 *
 * tone:
 *   "income"  — надходження (зелений)
 *   "outcome" — видаток (червоний)
 *   за замовчуванням — нейтральний колір тексту
 */
const Money = ({ value, currency = 'UAH', tone, className = '' }) => (
    <span className={`rc-money ${tone ? `rc-money--${tone}` : ''} ${className}`.trim()}>
        {formatCurrency(value ?? 0, currency)}
    </span>
);

export default Money;
